import { useSelector } from 'react-redux';

import type { IReduxStore } from '../interfaces/TReduxState';

export const useMainSelector = () => {
  return useSelector(({ main }: IReduxStore) => main);
};
